export { default } from './AddressDBTable';
